<template>
    <div v-if="visible" class="menu-overlay" @click.self="$emit('close')">
        <div class="menu-drawer">
            <router-link to="/home" class="menu-item" :class="{ active: currentUrl === 'home' }" @click.native="$emit('close')">
                <img class="iconImg" :src="currentUrl === 'home' ? require('../assets/mobile_menu_home_fill.svg') : require('../assets/mobile_menu_home.svg')"/>
                <span>{{ $t('mobile_foot1') }}</span>
            </router-link>
            <router-link v-if="productTypeList" :to="'/productList?type=' + productTypeList[0].id" class="menu-item" :class="{ active: currentUrl === 'product' }" @click.native="$emit('close')">
                <img class="iconImg" :src="currentUrl === 'product' ? require('../assets/mobile_menu_product_fill.svg') : require('../assets/mobile_menu_product.svg')"/>
                <span>{{ $t('mobile_foot2') }}</span>
            </router-link>
<!--            <router-link to="/news" class="menu-item" :class="{ active: currentUrl === 'news' }" @click.native="$emit('close')">
                <img class="iconImg" :src="currentUrl === 'news' ? require('../assets/mobile_menu_news_fill.svg') : require('../assets/mobile_menu_news.svg')"/>
                <span>{{ $t('mobile_foot3') }}</span>
            </router-link>-->
            <router-link to="/fileDownloadList" class="menu-item" :class="{ active: currentUrl === 'file' }" @click.native="$emit('close')">
                <img class="iconImg" :src="currentUrl === 'file' ? require('../assets/mobile_menu_file_fill.svg') : require('../assets/mobile_menu_file.svg')"/>
                <span>{{ $t('mobile_foot4') }}</span>
            </router-link>
            <a href="tel:15910967510" class="menu-item" @click="$emit('close')">
                <img class="iconImg" :src="currentUrl === 'tel' ? require('../assets/mobile_menu_tel_fill.svg') : require('../assets/mobile_menu_tel.svg')"/>
                <span>{{ $t('index_23') }}</span>
            </a>
        </div>
    </div>
</template>


<script>

import axios from "@/utils/axios";

export default {
    name: 'MobileNavBar',
    props: {
        visible: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            cp: this.GLOBAL.cp,
            productTypeList: null,
            currentUrl: null,
        }
    },
    watch: {
        $route() {
            this.formatPath()
        },
    },
    mounted() {
        axios.get(this.cp + '/jyy/portal/getProductTypeList')
            .then(res => {
                this.productTypeList = res.data
            })
        this.formatPath()
    },
    methods: {
        formatPath() {
            let path = this.$router.currentRoute.path;
            if (path.indexOf("home") !== -1) {
                this.currentUrl = "home";
            } else if (path.indexOf("product") !== -1) {
                this.currentUrl = "product";
            } else if (path.indexOf("news") !== -1) {
                this.currentUrl = "news";
            } else if (path.indexOf("file") !== -1) {
                this.currentUrl = "file";
            }
        },
    }
}
</script>


<style scoped>

.menu-overlay {
    position: fixed;
    top: 60px;
    left: 0;
    width: 100%;
    height: calc(100% - 60px);
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 200;
}

.menu-drawer {
    background-color: #fff;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.menu-item {
    display: flex;
    align-items: center;
    padding: 16px 24px;
    color: #333;
    font-size: 16px;
    border-bottom: 1px solid #f0f0f0;
    text-decoration: none;
}

.menu-item.active {
    color: #3675D9;
}

.menu-item:active {
    background-color: #f9f9f9;
}

.iconImg {
    width: 22px;
    margin-right: 14px;
}
</style>
